import { Button, Paper } from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { useStyles } from '../../theme/theme';
import { IconButton, Typography } from '@mui/material'
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";


const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
};

function Banks() {

    const [coupons, setCoupons] = useState([]);
    const [mockup, setMockup] = useState(0)
    const [page, setPage] = useState(0);
    const [limit, setLimit] = useState(10);
    const [isVerified, setIsVerified] = useState(true);
    const [isMore, setIsMore] = useState(false);
    const [nodata, setNodata] = useState(false);
    const [open, setOpen] = useState(false);
    const [isBankId, setIsBankId] = useState();
    const classes = useStyles();
    const [pageSize, setPageSize] = useState(25);
    const [rejectMsg, setRejectMsg] = useState("")

    const CouponsColomns = [
        {
            field: 's_no',
            headerName: 'S. No.',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            filterable: false,
            renderCell: (index) => index.api?.getRowIndexRelativeToVisibleRows(index.row._id) + 1,
        },
        {
            field: 'account_no',
            headerName: 'Account No.',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 150,
        },
        {
            field: 'bank_name',
            headerName: 'Bank Name',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'branch',
            headerName: 'Branch',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'is_verified',
            headerName: 'Is Verified',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 180,
            renderCell: (params) => {
                return (
                    <IconButton sx={{ borderRadius: 2 }}>{
                        <Typography color="error" onClick={() => {
                            setIsBankId(params?.row?._id);
                            setOpen(true);
                            setMockup(0)
                        }}>Not Verfifed</Typography>
                    }
                    </IconButton>
                )

            },
        },
        {
            field: 'account_type',
            headerName: 'Account type',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'holder_name',
            headerName: 'Holder name',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'region',
            headerName: 'Region',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'ifcs_code',
            headerName: 'IFSC Code',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
        {
            field: 'postal_code',
            headerName: 'Postal Code',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 130,
        },
        {
            field: 'publisher_id',
            headerName: 'Publisher Id',
            headerClassName: 'super-app-theme--header',
            flex: 1,
            minWidth: 200,
        },
    ]


    const fetchPublishers = () => {
        setPage(0);
        setNodata(true);
        setIsMore(false);
        axios.get(`admin/banks/verify/requests/0/1`).then((res) => {
            let data = res.data.response;
            if (res.data.status) {
                setCoupons(res.data.response);
                if (data && data.length < limit) {
                    setIsMore(true);
                }
                if (data.length === 0) {
                    setNodata(true);
                } else {
                    setNodata(false);
                }
                setPage(1);
            }
        });
    };

    const handleClose = () => {
        setOpen(false);
        setIsBankId("");
        setMockup(0);
        setRejectMsg("");
    }

    const verfiyHandler = async () => {
        let formData = {
            bank_id: isBankId,
            is_verified: 1,
            invalid_msg: ""
        }
        axios.patch(`/admin/bank/varify`, formData).then((res) => {
           
            if (res.data.status) {
                alert(res.data.message);
                fetchPublishers();
            }
        });
        handleClose()
    };
    const rejectHandler = () => {
        let formData = {
            bank_id: isBankId,
            is_verified: 2,
            invalid_msg: rejectMsg
        }
        axios.patch(`/admin/bank/varify`, formData).then((res) => {
            if(res.data.status_code==401){
                localStorage.clear()
              }
            if (res.data.status) {
                alert(res.data.message);
                fetchPublishers();
            }
        });
        handleClose()
    }

    useEffect(() => {
        fetchPublishers();
        return () => {
            setCoupons([]);
        };
    }, [isVerified]);

    return (
        <>
            <section

            >
                <section>
                    <section style={{ width: "45%" }}>


                        <div className={Dropdown.dropdown}>
                            <Button variant="contained" sx={{ ml: 1, my: 2 }} color='info' className={Dropdown.dropbtn}>Verified</Button>
                            <div className={Dropdown.dropdown_content}>
                                <a onClick={() => { setIsVerified(true); }}>True</a>
                                <a onClick={() => { setIsVerified(false); }}>False</a>
                            </div>
                        </div>
                    </section>
                </section>
                {nodata && !coupons.length == 0 && <section>Loading...</section>}

                <Paper sx={{
                    bgcolor: '#fff',
                    '& .super-app-theme--header': {
                        bgcolor: '#DC8449',
                        color: '#fff',
                    },
                }} elevation={0}>

                    {console.log("coupons-->", coupons)}
                    <DataGrid
                        className={classes.root}
                        sx={{
                            border: 0,
                        }}
                        hideFooterPagination
                        // getRowHeight={() => 'auto'}
                        autoHeight
                        rows={coupons}
                        columns={CouponsColomns}
                        getRowId={(row) => row._id}
                        disableSelectionOnClick
                        disableRowSelectionOnClick
                        experimentalFeatures={{ newEditingApi: true }}
                        // pagination
                        pageSize={pageSize}
                        disableColumnSelector
                    />
                </Paper>

            </section>
            <Modal
                open={open}
                onClose={() => handleClose()}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {
                            mockup === 0 ? "What you want to do?" : mockup === 1 ? "Are you Sure you Want to Verfiy" : mockup === 2 ? "Are you Sure you Want to Verfiy" : null
                        }

                    </Typography>

                    {mockup === 2 ? <>
                        <input
                            type="text"
                            name="holder_name"
                            className="inputTagReject"
                            required
                            value={rejectMsg}
                            onChange={(e) => {
                                setRejectMsg(e.target.value);
                            }}
                            placeholder='Reason For Rejection'

                        />

                    </> : null}
                    <Typography id="modal-modal-description" sx={{ mt: 2 }}>


                        {
                            mockup === 1 ?
                                <Button
                                    onClick={() => verfiyHandler()}
                                >
                                    Yes
                                </Button> : null
                        }
                        {
                            mockup === 2 ?
                                <Button
                                    onClick={() => rejectHandler()}
                                >
                                    Yes
                                </Button> : null
                        }
                        {mockup === 0 ? <>
                            <Button onClick={() => setMockup(1)} >Verfiy</Button>
                            <Button onClick={() => setMockup(2)}>Reject</Button>
                        </> :
                            <Button onClick={() => setMockup()} >
                                No
                            </Button>
                        }

                    </Typography>
                </Box>
            </Modal>

        </>
    );
}


export default Banks